/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import MainDispatcher from '../support/MainDispatcher';
import server from '../support/server';
import dash_api from '../support/dash_api';
import NotificationActions from './NotificationActions';
import { isOnSubdomain } from '../../common/support/utils';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
const ACCOUNT_PATH = '/v1/account';
const errorProvider = new ErrorProvider();

function handleAccountSaveError(err) {
  const field = errorProvider.parse(err).getFieldEmpty();
  const message = errorProvider.parse(err).getMessageOrEmpty();
  MainDispatcher.dispatch({
    action: 'ACCOUNT_ERROR',
    errors: {
      [field]: message,
    },
  });
}

export default {
  loadAccount: function () {
    MainDispatcher.dispatch({
      action: 'ACCOUNT_LOADING',
    });
    return server('account load').then(function (account) {
      MainDispatcher.dispatch({
        action: 'ACCOUNT_LOADED',
        account,
      });
    });
  },
  saveAccount: function (options: {
    name: string;
    password: string | null;
    password2: string | null;
    current_password: string;
    metadata?: any;
    last_name: string;
  }) {
    const { name, password, password2, current_password, metadata, last_name } = options;
    // In the dashboard, receiving `null` password arguments indicates the passwords shouldn't be
    // changed.
    const passwordGiven = password !== null && password2 !== null;
    // If we get passwords with text, this probably means we're actually trying to change our
    // password through the account settings page.
    const newPassword = !R.isNil(password) && !R.isNil(password2) && !R.isEmpty(password) && !R.isEmpty(password2);
    return server('account save', {
      name,
      password,
      password2,
      current_password,
      metadata,
      last_name,
    }).then((account) => {
      MainDispatcher.dispatch({
        action: 'ACCOUNT_SAVED',
        showNotification: passwordGiven,
        account,
      });

      // No need to logout if passwords weren't changed.
      if (newPassword) {
        this.resetPassword();
      }
    }, handleAccountSaveError);
  },
  updateEmail: function (newEmail: string) {
    return dash_api
      .put(ACCOUNT_PATH + '/email', {
        email: newEmail,
      })
      .then((account) => {
        MainDispatcher.dispatch({
          action: 'ACCOUNT_SAVED',
          account,
        });
        server('loggedout/logout').then(() => (window.location = '/login'));
      }, handleAccountSaveError);
  },
  resetPassword: function (token?: string) {
    const appendedPath = token ? '/' + token : '';
    server('loggedout/logout').then(() => (window.location = '/login' + appendedPath));
  },
  logout: function () {
    const onSubdomain = isOnSubdomain(window.location.host);

    if (onSubdomain) {
      return dash_api
        .delete('/sso/logout')
        .then(() => {
          window.location = '/sso/login';
        })
        .catch((e) => {
          NotificationActions.showNotification(
            'Failed to logout. Please try logging out from your identity provider directly.',
            'error'
          );
        });
    }

    server('loggedout/logout').then((response) => {
      window.location = '/login';
    });
  },
};
